import { generateRandomId } from "./Equation";

const handleTabletoText = (editor) => {
  const node = editor.selection.getNode();

  const tableWrap = editor.dom.getParent(node, "table-wrap");

  if (!tableWrap || tableWrap.getAttribute("data-type") !== "algorithm") {
    return false;
  }

  let clone = tableWrap.cloneNode(true);

  let newContent = document.createDocumentFragment();
  let label = clone.querySelector("label");
  let title = clone.querySelector("title1");

  let titleTag = document.createElement("p");
  let tkey = generateRandomId("Alti_");
  titleTag.setAttribute("key", tkey);
  if (label) {
    for (let attr of label.attributes) {
      label.setAttribute(attr.name, attr.value);
    }
    titleTag.appendChild(label);
  }
  for (let attr of title.attributes) {
    title.setAttribute(attr.name, attr.value);
  }

  titleTag.appendChild(title);

  newContent.appendChild(titleTag);

  clone.querySelectorAll("tr").forEach((tr) => {
    let pTag = document.createElement("p");

    tr.querySelectorAll("td").forEach((td) => {
      for (let attr of td.attributes) {
        pTag.setAttribute(attr.name, attr.value);
      }

      pTag.innerHTML += td.innerHTML + " ";
    });

    newContent.appendChild(pTag);
  });

  tableWrap.parentNode.replaceChild(newContent, tableWrap);

  return true;
};

const handleTexttoTable = (editor, title) => {
  const selectedHtml = editor.selection.getContent({ format: "html" });

  const allTable = editor.dom
    .select("table-wrap")
    .map((el) => el.getAttribute("id"))
    .filter((id) => id)
    .sort((a, b) => {
      const numA = parseInt(a.replace(/\D/g, ""), 10);
      const numB = parseInt(b.replace(/\D/g, ""), 10);
      return numA - numB;
    });
  const lastId = allTable.length > 0 ? allTable[allTable.length - 1] : null;
  const lastNum = lastId ? parseInt(lastId.replace(/\D/g, ""), 10) + 1 : 1;
  const newId = `table-${lastNum}`;
  const hasParentTag = /^\s*<[^>]+>/.test(selectedHtml.trim());
  const tempDiv = document.createElement("div");

  if (hasParentTag) {
    tempDiv.innerHTML = selectedHtml;
  } else {
    const P1 = document.createElement("p");
    P1.innerHTML = selectedHtml;
    tempDiv.appendChild(P1);
  }
  const tableWrap = document.createElement("table-wrap");
  let tkey = generateRandomId("twra_");
  tableWrap.setAttribute("key", tkey);
  tableWrap.setAttribute("data-type", "algorithm");
  tableWrap.setAttribute("id", newId);

  const firstTag = tempDiv.childNodes[0].textContent.includes("Algorithm");

  // Create a new table
  const alternatives = document.createElement("alternatives");
  const table = document.createElement("table");
  const tbody = document.createElement("tbody");
  let takey = generateRandomId("tab_");
  let tbkey = generateRandomId("tbod_");
  let altkey = generateRandomId("Alter_");
  table.setAttribute("key", takey);
  tbody.setAttribute("key", tbkey);
  alternatives.setAttribute("key", altkey);

  const allTables = editor
    .getBody()
    .querySelectorAll('table-wrap[data-type="algorithm"]');
  let highestNumber = 0;

  allTables.forEach((table) => {
    const label = table.querySelector("label");
    if (label) {
      const text = label.textContent.trim();
      const match = text.match(/Algorithm\s*(\d+):?/i); // extract the number
      if (match) {
        const num = parseInt(match[1]); // convert to number
        if (num > highestNumber) {
          highestNumber = num; // update highest number
        }
      }
    }
  });

  if (title) {
    const lab = document.createElement("label");
    let lkey = generateRandomId("TAla_");
    lab.setAttribute("key", lkey);
    lab.textContent = `Algorithm ${highestNumber + 1}:`;
    const title1 = document.createElement("title1");
    let Titkey = generateRandomId("TATI_");
    title1.setAttribute("key", Titkey);
    title1.textContent = title;

    tableWrap.appendChild(lab);
    tableWrap.appendChild(title1);
  } else if (firstTag) {
    let firstLabel = tempDiv.childNodes[0].querySelector("label");
    let firstTitle = tempDiv.childNodes[0].querySelector("title1");

    if (firstLabel && firstTitle) {
      tableWrap.appendChild(firstLabel);
      tableWrap.appendChild(firstTitle);
    } else {
      const text = tempDiv.childNodes[0].textContent.trim();
      const match = text.match(/^(Algorithm\s*\d+:)\s*(.+)$/i);

      if (match) {
        const algorithmPart = match[1]; // "Algorithm 2:"
        const descriptionPart = match[2]; // rest of the text

        const newLabel = document.createElement("label");
        newLabel.textContent = algorithmPart;

        const descTag = document.createElement("title1");
        descTag.textContent = descriptionPart;

        tableWrap.appendChild(newLabel);
        tableWrap.appendChild(descTag);
      }
    }
  }
  // Loop through all direct children in the selection
  tempDiv.childNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      let tr = document.createElement("tr");
      let trkey = generateRandomId("TR_");
      tr.setAttribute("key", trkey);
      const td = document.createElement("td");
      td.innerHTML = node.innerHTML;

      // Copy attributes from node
      for (let attr of node.attributes) {
        td.setAttribute(attr.name, attr.value);
      }

      tr.appendChild(td);

      if (tr.innerText.trim()) {
        tbody.appendChild(tr);
      }
    }
  });

  table.appendChild(tbody);
  alternatives.appendChild(table);
  tableWrap.appendChild(alternatives);

  // Replace the selected content with the new table
  editor.selection.setNode(tableWrap);
  return true;
};

const handleCheckText = (editor) => {
  const selection = editor.selection;

  if (!selection || selection.isCollapsed()) {
    return {
      success: false,
      title: true,
    };
  }

  const selectedHtml = selection.getContent();
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = selectedHtml;

  if (!tempDiv.firstChild || tempDiv.textContent.trim() === "") {
    return {
      success: false,
      title: true,
    };
  }
  const firstTag = tempDiv.childNodes[0].textContent.includes("Algorithm");
  if (!firstTag) {
    return {
      success: false,
      title: false,
    };
  }
  return {
    success: true,
    title: true,
  };
};
export { handleTabletoText, handleTexttoTable, handleCheckText };
